import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const EarthlinkPerksExisting = ({ phoneNumber }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="perks-below-slider__card">
        <div className="perks-below-slider__cardTitle">
          {t('products.existingContactTitle')}
        </div>
        <a className="perks-below-slider__btn" href={`tel:${phoneNumber}`}>
          <i className="fa-solid fa-phone" aria-hidden="true" /> {phoneNumber}
        </a>
        <div className="perks-below-slider__cardNote">
          {t('products.existingCallNow')}
        </div>
      </div>
    </>
  );
};

EarthlinkPerksExisting.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
};

export default EarthlinkPerksExisting;
